import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { SezioneEconomica } from 'src/app/common/models/sezioni/sezione-economica';
import { ModalNotifyService } from 'src/app/core/services/modal-notify.service';
import { DatiGeneraliConFondoRischiForm } from "../../../common/form/dati-generali-con-fondo-rischi-form";
import { AutoritaGiudiziaria } from "../../../common/models/tipologiche/autorita-giudiziaria";
import { Grado } from "../../../common/models/tipologiche/grado";
import { SedeTerritoriale } from "../../../common/models/tipologiche/sede-territoriale";
import { TipoNatura } from "../../../common/models/tipologiche/tipo-natura";
import { FormValidationService } from "../../../common/services/form-validation.service";
import { HelpersService } from "../../../core/services/helpers.service";
import { OperationsService } from "../../../core/services/operations.service";
import { OperationsUrlSettingsFascicolo } from '../../fascicoloGeneric/configuration/operations-url-settings-fascicolo';
import { MetadataExt } from 'src/app/common/models/metadati/metadata';
import { ProtocolMetadata } from 'src/app/common/protocol/models/protocol';

@Component({
  selector: 'app-form-opposizione-esecuzione',
  templateUrl: './form-opposizione-esecuzione.component.html',
  styleUrls: ['./form-opposizione-esecuzione.component.css']
})
export class FormOpposizioneEsecuzioneComponent extends DatiGeneraliConFondoRischiForm implements OnInit, OnChanges {

  datiGeneraliForm: FormGroup;
  tipiNatura: TipoNatura[] = [];
  autoritaGiudiziarie: AutoritaGiudiziaria[] = [];
  cittaPerAutoritaGiudiziaria: SedeTerritoriale[] = [];
  gradi: Grado[] = [];
  idPratica: string;
  tipoFascicolo: string;
  tipoPratica: number;
  gradoSubscription: Subscription;
  genericFascicolo: string;
  idFascicolo: string;
  gradoFascicolo: any;
  sezioneEconomicaFascicolo: SezioneEconomica;
  metadataFormValid: boolean = false;
  protocollo: ProtocolMetadata;

  @Input() fascicolo;
  @Input() request;
  @Input() nomeFascicolo;
  @Input() labelCreatoDaSistema;
  @Input() minervaWizard = false;
  @Output() saveForm = new EventEmitter();
  @Output() resetForm = new EventEmitter();
  @Output() createForm = new EventEmitter();

  constructor(protected operationService: OperationsService,
              private formValidationService: FormValidationService,
              private campiForm: FormBuilder,
              private helpers: HelpersService,
              private modalNotifyService: ModalNotifyService,
              private activatedRoute: ActivatedRoute) {
    super();
    activatedRoute.params.subscribe( params => {
      this.genericFascicolo = params.genericFascicolo;
      this.idFascicolo = params.idFascicolo;
    });
  }

  ngOnInit() {
    this.createFascicoloForm(true);
    this.populateSelect();
    this.inizializzaFondoRischi(this.request.fascicolo.flagFondoRischi, this.request.fascicolo.dataVariazioneFondoRischi);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.request && changes.request.currentValue) {
      this.createFascicoloForm();
    }
  }

  createFascicoloForm(init = false) {
    this.datiGeneraliForm = this.campiForm.group({
      posizione: [init ? null : this.request.fascicolo.posizione],
      tipo: [init ? null : this.request.fascicolo.tipoFascicolo],
      natura: [init ? null : this.request.fascicolo.natura, Validators.required],
      stato: [init ? null : this.request.fascicolo.stato],
      tipoVisibilita: [init ? null : this.request.fascicolo.tipoVisibilita],
      dataInizioFascicolo: [init ? null : this.request.fascicolo.dataInizioFascicolo, Validators.required],
      flagProcessoTelematico: [init ? null : this.request.fascicolo.flagProcessoTelematico],
      definito: [init ? null : this.request.fascicolo.definito],
      dataDefinizione: [init ? null : this.request.fascicolo.dataDefinizione],
      motivoDefinizione: [init ? null : this.request.fascicolo.motivoDefinizione],
      flagFondoRischi: [init ? null : this.request.fascicolo.flagFondoRischi],
      recuperoCrediti: [init ? false : this.request.fascicolo.recuperoCrediti],
      //dataVariazioneFondoRischi: [init ? null : this.request.fascicolo.dataVariazioneFondoRischi],
      grado: [init ? null : this.request.fascicolo.grado],
      nruolo: [init ? null : this.request.fascicolo.numeroRuolo],
      annoRuolo: [init ? null : this.request.fascicolo.annoRuolo, Validators.compose([this.formValidationService.anno])],
      autoritaGiudiziaria: [init ? null : this.request.fascicolo.autoritaGiudiziaria, Validators.required],
      autoritaGiudiziariaCitta: [init ? null : this.request.fascicolo.autoritaGiudiziariaCitta, Validators.required],
      sezione: [init ? null : this.request.fascicolo.sezione],
      giudice: [init ? null : this.request.fascicolo.giudice],
      motivoOpposizione: [init ? null : this.request.fascicolo.motivoOpposizione],
      numRuoloDecretoRif: [init ? null : this.request.fascicolo.numRuoloDecretoRif],
      dataInizioFascicoloRif: [init ? null : this.request.fascicolo.dataInizioFascicoloRif],
      posizioneFascicoloRif: [init ? null : this.request.fascicolo.posizioneFascicoloRif],
      valoreFascicoloRif: [init ? null : this.request.fascicolo.valoreFascicoloRif],
      note: [init ? null : this.request.fascicolo.note],
      metadata: [init ? null : this.request.fascicolo.metadata],
      descrizioneOggetto: [init ? null : this.request.fascicolo.descrizioneOggetto, Validators.required],
    });
    if(!this.inserimento && !this.minervaWizard){
      this.gradoFascicolo = {...this.request.fascicolo.grado};
      this.readSezioneEconomica();
    }
    if(this.minervaWizard){
      this.createForm.emit();
    }
    this.readProtocollo()
  }

  getSediByAutorita() {
    if (this.request.fascicolo.autoritaGiudiziaria) {
      this.helpers.getCittaPerAutoritaGiudiziaria(this.request.fascicolo.autoritaGiudiziaria.id).subscribe(response => this.cittaPerAutoritaGiudiziaria = response);
    }
  }


  populateSelect() {

    if (this.gradi.length === 0) {
      this.helpers.getGradi().subscribe(response => this.gradi = response);
    }
    if (this.autoritaGiudiziarie.length === 0) {
      this.helpers.getAutoritaGiudiziarie().subscribe(response => this.autoritaGiudiziarie = response);
    }
    if (this.request.fascicolo && this.request.fascicolo.autoritaGiudiziaria && this.request.fascicolo.autoritaGiudiziaria.id) {
      this.helpers.getCittaPerAutoritaGiudiziaria(this.request.fascicolo.autoritaGiudiziaria.id).subscribe(response => this.cittaPerAutoritaGiudiziaria = response);
  }
  }

  readSezioneEconomica(){
    this.operationService.readFascicolo(OperationsUrlSettingsFascicolo.URL_GET_FASCICOLO(this.genericFascicolo), this.request.fascicolo.id).subscribe(response=>{
      if(response.fascicolo.idSezioneDatiEconomici && !this.sezioneEconomicaFascicolo){
        this.operationService.readSezione(OperationsUrlSettingsFascicolo.URL_GET_SEZIONE_ECONOMICA(this.genericFascicolo), response.fascicolo.idSezioneDatiEconomici).subscribe(response=>{
          this.sezioneEconomicaFascicolo = response.sezione;
        });
      }
    });
  }

  changedGrado(): boolean {
    return this.request.fascicolo.grado ? (this.gradoFascicolo.id && this.request.fascicolo.grado.id!==this.gradoFascicolo.id) : !!(this.gradoFascicolo.id)
  }

  checkContributoUnificato(): boolean {
    if(!this.sezioneEconomicaFascicolo){
      this.readSezioneEconomica();
    }
    return (this.changedGrado() && this.sezioneEconomicaFascicolo && !!this.sezioneEconomicaFascicolo.contributoUnificato);
  }

  isFormMetadataValid(value: boolean){
    this.metadataFormValid = value;
  }

  onRetrieve(value : MetadataExt[]){
    this.request.fascicolo.metadata = value.map(value => value);
  }

  onDataProtocol(value: ProtocolMetadata) {
    if (value) {
      this.request.fascicolo.numeroFascicoloProtocollo = value.dossierNumber;
      this.request.fascicolo.numeroProtocollo = value.protocolNumber;
      this.request.fascicolo.dataProtocollazione = value.protocolTimestamp;
      this.request.fascicolo.oggettoProtocollo = value.subject;
      this.request.fascicolo.senderReceiver = value.senderReceiver;
      this.request.fascicolo.utenteProtocollatore = value.protocolUser;
      this.request.fascicolo.inUscita = value.tipoReg.toLowerCase() === "in uscita";
      this.request.fascicolo.protocolDocuments = value.protocolDocuments.map(d => (d.documentRef));
    } else {
      this.request.fascicolo.numeroFascicoloProtocollo = null;
      this.request.fascicolo.numeroProtocollo = null;
      this.request.fascicolo.dataProtocollazione = null;
      this.request.fascicolo.oggettoProtocollo = null;
      this.request.fascicolo.senderReceiver = null;
      this.request.fascicolo.utenteProtocollatore = null;
      this.request.fascicolo.inUscita = null;
      this.request.fascicolo.protocolDocuments = null;
    }
  }
  readProtocollo() {
    if(this.fascicolo.numeroProtocollo){
      this.protocollo={
      dossierNumber: this.fascicolo.numeroFascicoloProtocollo,
      protocolNumber: this.fascicolo.numeroProtocollo,
      protocolTimestamp: this.fascicolo.dataProtocollazione,
      subject: this.fascicolo.oggettoProtocollo,
      senderReceiver:this.fascicolo.senderReceiver,
      protocolUser: this.fascicolo.utenteProtocollatore,
      tipoReg: this.fascicolo.inUscita ? "IN USCITA" : "IN ENTRATA"
    }}
  }

  save() {
    if(!this.inserimento && !this.minervaWizard && !!this.checkContributoUnificato()){
      this.gradoSubscription = this.modalNotifyService.notifyConfirmObservable.subscribe(result =>{
        if(!!result){
          this.saveForm.emit();
        } else{
          this.gradoSubscription.unsubscribe();
        }
      });
      this.modalNotifyService.notifyCustom('Confermando il cambio del tipo di grado di rischio, verrà annullato il valore inserito nel contributo unificato. Continuare?');
    } else{
      this.saveForm.emit();
    }
  }
}
